var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGyGuyana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19170)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7754 0H0.000392914V45H59.7754V0Z",
    fill: "#399408"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9812 0C60.0656 0 1.89375 22.6406 1.89375 22.6406L60 44.9812L59.9812 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9717 1.8938C59.6529 1.8938 7.56543 22.3219 7.85605 22.5188L59.8217 43.425L59.9717 1.90317V1.8938Z",
    fill: "#FFDE08"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8217 0.0749512C59.6529 0.0749512 32.5498 22.6593 32.5498 22.6593L59.8311 44.7187V0.0749512H59.8217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9721 3.17813C59.8221 1.77188 35.5127 22.7156 35.5127 22.7156L59.9814 42.3469V3.17813H59.9721Z",
    fill: "#DE2110"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyGuyana);
export default __webpack_public_path__ + "static/media/gy Guyana.7f00024e249d8eaa33d0ae9c570e2558.svg";
export { ForwardRef as ReactComponent };